import { Banner } from "@/ui/Banner";
import { Col, Row } from "react-bootstrap";
import { DynamicText } from "@/ui/DynamicText";
import { useLocale } from "@/hooks/useLocale";
import { DynamicHtml } from "@/ui/DynamicHtml";

export const RegisterPageBannerSection = ({ className, pathPrefix }) => {
  const locale = useLocale();

  return (
    <Banner
      className={className}
      title={<DynamicText path={`${pathPrefix}.banner.title.${locale}`} tag="h1" />}
      image={{ path: `${pathPrefix}.banner.image`, src: "/assets/banners/default.webp" }}
      variant="quaternary"
    >
      <Row>
        <Col xs={12} md={6}>
          <DynamicHtml path={`${pathPrefix}.banner.text.${locale}`} />
        </Col>
      </Row>
    </Banner>
  );
};

RegisterPageBannerSection.defaultProps = {
  pathPrefix: "page.register",
};
